import React from "react";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness6';
import {ColorModeContext} from "../../App";
import {useTranslation} from "react-i18next";
import {AnimatedIconButtonWithLabel} from "../general/button/IconButtonWithLabel";
import {useTheme} from "@mui/material";

export default function ThemeButton(props) {
    const {t} = useTranslation('common');
    const theme = useTheme();
    const colorMode = React.useContext(ColorModeContext);

    return (
        <AnimatedIconButtonWithLabel
            {...props}
            onClick={colorMode.toggleColorMode}
            label={t('main.components.button.theme')}
        >
            {theme.palette.mode === 'dark' ? <Brightness7Icon/> : <Brightness4Icon/>}
        </AnimatedIconButtonWithLabel>
    );
}